/**
 * Returns the platform's AudioContext constructor, falling back to the
 * `webkitAudioContext` prefix used by older WebKit-based browsers (notably
 * legacy Safari/iOS). The returned value is the constructor itself, so callers
 * instantiate it with `new (getAudioContextConstructor())()`.
 *
 * @returns The standard `AudioContext` constructor when available, otherwise
 *   the `webkitAudioContext` constructor. May be `undefined` in environments
 *   that expose neither (the return type stays `typeof AudioContext` for
 *   ergonomic call sites; guard before constructing if support is uncertain).
 */
export function getAudioContextConstructor(): typeof AudioContext {
  return (
    window.AudioContext ??
    (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  ) as typeof AudioContext;
}
